import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    deleteDailySubContractor,
    DeleteDailySubContractorResponse,
    createDailySubContractor,
    CreateDailySubContractorBody,
    DailySubContractorResponse,
    updateDailySubContractor,
    UpdateDailySubContractorBody,
} from '../../services/apiSLTP/dailyReports/dailySubContractors';

type UseDeleteDailySubContractorMutationOptions = MutationOptions<DeleteDailySubContractorResponse, Error, { id: string }>;

export const useDeleteDailySubContractorMutation = (options?: UseDeleteDailySubContractorMutationOptions) => {
    const deleteDailySubContractorMutation: MutationFunction<DeleteDailySubContractorResponse, { id: string }> = async ({ id }) => {
        try {
            const response: DeleteDailySubContractorResponse = await deleteDailySubContractor(id);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during delete daily temp worker');
        }
    };

    return useMutation(deleteDailySubContractorMutation, options);
};

type UseCreateDailySubContractorMutationOptions = MutationOptions<DailySubContractorResponse, Error, { body: CreateDailySubContractorBody }>;

export const useCreateDailySubContractorMutation = (options?: UseCreateDailySubContractorMutationOptions) => {
    const createDailySubContractorMutation: MutationFunction<DailySubContractorResponse, { body: CreateDailySubContractorBody }> = async ({
        body,
    }) => {
        try {
            const response: DailySubContractorResponse = await createDailySubContractor(body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during create daily temp worker');
        }
    };

    return useMutation(createDailySubContractorMutation, options);
};

type UseDailySubContractorMutationOptions = MutationOptions<DailySubContractorResponse, Error, { id: string; body: UpdateDailySubContractorBody }>;

export const useDailySubContractorMutation = (options?: UseDailySubContractorMutationOptions) => {
    const updateDailySubContractorMutation: MutationFunction<
        DailySubContractorResponse,
        { id: string; body: UpdateDailySubContractorBody }
    > = async ({ id, body }) => {
        try {
            const response: DailySubContractorResponse = await updateDailySubContractor(id, body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during update daily temp worker');
        }
    };

    return useMutation(updateDailySubContractorMutation, options);
};
